<template>
	<div class="main" v-if="info.hasOwnProperty('id')" v-wechat-title="region.re_name+('-皖云游-'+info.type_name)+'-'+ info.DicName">
		<TravelTop :info="info" :region="region" />

		<TravelAbout v-if="simages.hasOwnProperty(1)" :simages="simages[1]" :summary="info.Summary" />
		<TravelAudio :audios="audios" />
		<div class="container">
			<div class="panel panel-default">
				<div class="panel-heading">
					<div class="category">
						<a class="category-top">基本资料</a>
						<a class="category-bottom">Basic data</a>
					</div>
				</div>
				<div class="panel-body" style="padding:0px;">
					<div class="container">
            <table class="table">
                    <thead>
                        <tr>
                            <th width="18%"></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td class="blue"><p>名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称</p></td><td>{{info.DicName?info.DicName:'暂无'}}</td></tr>
                        <tr><td class="blue"><p>类&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;型</p></td><td>{{info.FoodType?info.FoodType:'暂无'}}</td></tr>
                        <tr>
                          <td class="blue"><p>行政区划</p></td>
                          <td v-if="info.city && info.district">安徽省-{{info.city.RegionName}}-{{info.district.RegionName}}{{info.town?'-'+info.town.RegionName:''}}</td>
                          <td v-else>暂无</td>
                        </tr>
                        <tr><td class="blue"><p>地理位置</p></td><td>{{info.Address?info.Address:'暂无'}}</td></tr>
                        <tr><td class="blue"><p>品质特征</p></td><td>{{info.QualityFeature?info.QualityFeature:'暂无'}}</td></tr>
                        
                        <tr><td class="blue"><p>主要成分</p></td><td>{{info.MainMaterial?info.MainMaterial:'暂无'}}</td></tr>
                        <tr><td class="blue"><p>市场价格</p></td><td>{{info.MarketPrice?info.MarketPrice:'暂无'}}</td></tr>
                        <tr><td class="blue"><p>联系方式</p></td><td><a :href="info.Telphone?'tel:'+info.Telphone:'#'">{{info.Telphone?info.Telphone:'暂无'}}</a></td></tr>
                        <tr><td class="blue"><p>功&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;效</p></td><td>{{info.Efficiency?info.Efficiency:'暂无'}}</td></tr>
                        <tr><td class="blue"><p>获奖荣誉</p></td><td>{{info.Honour?info.Honour:'暂无'}}</td></tr>
                        <tr style="height:20px;"><td></td><td></td></tr>
                    </tbody>
                </table>
            
						
						
					</div>
				</div>
			</div>
		</div>
		<TravelMap :info="info" :center="center" :region="region" />
		<!--平面导览-->
		<TravelImage v-if="simages.hasOwnProperty(2)" :simages="simages[2]" />

		<TravelVideo :videos="videos" />

		<TravelEcommerce :list="ecommerces" />
    <TravelDetail name="历史发展" enname="History development" :detail="info.History" />
		<TravelDetail name="生产工艺" enname="Production process" :detail="info.Production" />
		<TravelDetail name="价值功效" enname="Value effect" :detail="info.ValueEffect" />
		<TravelDetail name="商品文化" enname="Tourism commodity" :detail="info.Culture" />
    <TravelDetail name="荣誉奖项" enname="Honor prize" :detail="info.HonourDetail" />
		<TravelDetail name="品牌推荐" enname="Brand recommend" :detail="info.BrandRecommend" />

		<Scolllist></Scolllist>
		<!-- 相关词条 -->
		<TravelRelevant :dicrelevants="dicrelevants"/>
		<TravelFooter :info="info" :region="region" />
	</div>
</template>
<script>

import Scolllist from "@/components/Scolllist";
import { travelInfo } from '@/api/travel'
import TravelDetail from '@/components/travel/detail'
import TravelRelevant from '@/components/travel/relevant'
import TravelScenicmianspots from '@/components/travel/scenicmianspots'
import TravelVideo from '@/components/travel/video'
import TravelImage from '@/components/travel/image'
import TravelMap from '@/components/travel/map'
import TravelAbout from '@/components/travel/about'
import TravelTop from '@/components/travel/top'
import TravelFooter from '@/components/travel/footer'
import TravelAudio from '@/components/travel/audio'
import TravelLocalcelebrity from '@/components/travel/localcelebrity'
import TravelEcommerce from '@/components/travel/ecommerce'
import TravelRoom from '@/components/travel/room'
import TravelFacilities from '@/components/travel/facilities'
import TravelDish from '@/components/travel/dish'
export default {
    data() {
        return {
            info: this.$store.state.acc,
            user: this.$store.state.user,
            center: { lng: 0, lat: 0 },
            info: {},
            region: {},
            simages: {},
            ecommerces: [],
            traffic: {},
            dicrelevants: [],
            videos:[],
            audios:[],
            localcelebrities: [],
            rooms: [],
            meetings: [],
            facilities: [],
            dishs: [],
            balconies: [],
        }
    },
    components: {
			TravelMap,
			TravelDetail,
			TravelRelevant,
			TravelScenicmianspots,
			TravelVideo,
			TravelImage,
			TravelAbout,
			TravelTop,
			TravelFooter,
			TravelAudio,
			TravelLocalcelebrity,
			TravelEcommerce,
			TravelRoom,
			TravelFacilities,
			TravelDish,
      Scolllist
		},
    created(e) {
    	this.getInfo()
    },
    methods: {
    	getInfo (){
    		this.$toast.loading({
		      message: '加载中...',
		      forbidClick: false,
		      loadingType: 'spinner',
		      duration: 10000
		    });
    		travelInfo({type: 'Commoditie', id: this.$route.params.id}).then(res=> {
    			this.$toast.clear()
          this.info = res.info
          this.region = res.Region
          this.$store.commit('SET_RGION', this.region)
          this.simages = res.Images
          this.traffic = res.traffic
          this.audios = res.audios
          this.videos = res.videos
          this.balconies = res.balconies
          this.dishs = res.dishs
          this.facilities = res.facilities
          this.localcelebrities = res.localcelebrities
          
          this.ecommerces = res.ecommerces
          this.dicrelevants = res.dicrelevants

    		})
    	},
    	
    }
};
</script>
<style>
	body{
		height: auto;
	}
</style>